import React from 'react';

import { LoadingText } from '@fragment/ui/src/components/LoadingText';

export const SettingsPageLoading = () => (
  <span data-testid="settings-page-loading">
    <LoadingText text="" />
  </span>
);
